import { IonSegment, IonSegmentButton } from '@ionic/react';
import { ComponentProps } from 'react';

import styles from '@/components/SegmentedControl/index.module.css';

import { mergeClassNames } from '@/utils/mergeClassNames';

export type SegmentButton = ComponentProps<typeof IonSegmentButton>;
interface SegmentedControlProps extends ComponentProps<typeof IonSegment> {
  segments: SegmentButton[];
  variant?: 'default' | 'condensed';
}

export const SegmentedControl = ({ segments, variant = 'default', ...props }: SegmentedControlProps) => {
  return (
    <IonSegment className={mergeClassNames(styles.control, styles[variant])} mode='ios' {...props} scrollable={true}>
      {segments.map((segment) => (
        <IonSegmentButton
          value={segment.value}
          {...segment}
          className={mergeClassNames(segment.className, styles.button, styles[variant])}
          key={segment.value}>
          {segment.title}
        </IonSegmentButton>
      ))}
    </IonSegment>
  );
};
